import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CompanyService } from 'src/app/_services/company.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserService } from 'src/app/_services/user.service';
import { FleetGeneralInsightsService } from 'src/app/_services/fleet-general-insights.service';
import { BatteryTypeOption, ALL_BATTERY_TYPES, toBatteryTypeOptions } from 'src/app/_shared/utils/battery-type';

@Component({
  selector: 'app-fleet-mgmt',
  templateUrl: './fleet-mgmt.component.html',
  styleUrls: ['./fleet-mgmt.component.scss']
})
export class FleetMgmtComponent implements OnInit, OnDestroy {
  @Input() fleetId: string[] = [];
  companyData: any;
  isMetric: boolean | undefined;
  batteryTypes: BatteryTypeOption[] = [];
  selectedBatteryTypes: BatteryTypeOption[] = [];
  batteryTypesLoadingError = false;
  readonly maxSelectableBatteryTypes = 3;
  private readonly unsubscribe$ = new Subject<void>();
  
  constructor(
    private readonly companyService: CompanyService,
    private readonly userService: UserService,
    private readonly fleetGeneralInsightsService: FleetGeneralInsightsService
  ) { }
  
  ngOnInit(): void {
    const credentials = sessionStorage.getItem(`credentials_${environment.appId}`);
    if(credentials) {
      const parsedCredentials = JSON.parse(credentials);
      this.companyService.getCompanyData(parsedCredentials.database).pipe(takeUntil(this.unsubscribe$)).subscribe({
        next: (company) => {
          this.companyData = company;
        },
        error: (error) => {
          console.error('Error fetching company:', error);
        }
      })
      this.userService.getUser(parsedCredentials.userName, parsedCredentials.database).pipe(takeUntil(this.unsubscribe$)).subscribe({
        next: (user) => {
          this.isMetric = user?.isMetric ?? null;
          console.log('User metric preference:', this.isMetric);
        },
        error: (error) => {
          console.error('Error fetching user:', error);
        }
      });
    } else {
      console.error('Error fetching credentials.');
    }
    this.fetchBatteryTypes();
  }

  fetchBatteryTypes(): void {
    if (this.fleetId.length === 0) {
      return;
    }
    this.batteryTypesLoadingError = false;
    this.fleetGeneralInsightsService.getBatteryTypes(this.fleetId[0]).pipe(takeUntil(this.unsubscribe$)).subscribe({
      next: (response) => {
        this.batteryTypes = toBatteryTypeOptions(response);
        if (this.selectedBatteryTypes.length === 0 && this.batteryTypes.length > 0) {
          const defaultOption = this.batteryTypes.find((option) => option.batteryType === ALL_BATTERY_TYPES);
          this.selectedBatteryTypes = [defaultOption ?? this.batteryTypes[0]];
        }
      },
      error: (error) => {
        console.error('Error fetching Battery Types:', error);
        this.batteryTypesLoadingError = true;
      }
    });
  }

  onBatteryTypeSelected(selectedValue: any): void {
    let selection: BatteryTypeOption[] = Array.isArray(selectedValue) ? selectedValue : [];
    if (selection.length > this.maxSelectableBatteryTypes) {
      selection = selection.slice(selection.length - this.maxSelectableBatteryTypes);
    }
    this.selectedBatteryTypes = [...selection];
  }
  
  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  
}
